import { appLocalStorage } from '../../../../../BackOffice-UI/src/app/shared/commonURLs';

let VisitManagementODataUrl = appLocalStorage.VisitManagementODataUrl;
let VisitManagementUrl = appLocalStorage.VisitManagementUrl;
let SecurityOdataServiceUrl = appLocalStorage.SecurityOdataServiceUrl;
let pmgtURL = appLocalStorage.PmgtServiceUrl;
let nphiesURL = appLocalStorage.NphiesUrl;
let nphiesODataUrl = appLocalStorage.NphiesODataUrl;
let mpiURl = appLocalStorage.MedicalRecordsURL;
let cpoeURL = appLocalStorage.CpoeUrl;

export class VMModuleURls {
    constructor() {
        this.VMServicesList = VisitManagementURls();
    }
}

const VisitManagementURl = new VMModuleURls();

export { VisitManagementURl };

function VisitManagementURls() {

    var services = {};

    services["DeleteWaseleMapping"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'Wasele/DeleteWaseleMapping'
    }

    services["AddNewVisitServiceReportDisplayMapping"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'Wasele/AddNewVisitServiceReportDisplayMapping'
    }

    services["InitWaseleScreen"] = {
        Method: 'Get',
        URL: VisitManagementUrl + 'Wasele/InitWaseleScreen'
    }

    services["GetDiscountRules"] = {
        Method: 'Get',
        URL: VisitManagementODataUrl + 'DiscountRuleOData'
    }
    services["GetWaseleData"] = {
        Method: 'Get',
        URL: VisitManagementODataUrl + 'VisitServiceReportDisplayMappingOData'
    }

    services["AddDiscountRule"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'DiscountRule/AddDiscountRule'
    }

    services["EditDiscountRule"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'DiscountRule/EditDiscountRule'
    }

    services["DeleteDiscountRule"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'DiscountRule/DeleteDiscountRule'
    }

    services["IsRuleAssignedToUser"] = {
        Method: 'Get',
        URL: VisitManagementUrl + 'DiscountRule/IsRuleAssignedToUser'
    }

    services["InitAddDiscountRuleDetails"] = {
        Method: 'Get',
        URL: VisitManagementUrl + 'DiscountRuleDetails/InitAddDiscountRuleDetails'
    }

    services["AddEditDiscountRuleDetails"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'DiscountRuleDetails/AddEditDiscountRuleDetails'
    }
    services["EditDiscountRuleDetails"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'DiscountRuleDetails/EditDiscountRuleDetails'
    }

    services["DeleteDiscountRuleDetails"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'DiscountRuleDetails/DeleteDiscountRuleDetails'
    }
    services["GetAllDiscountRules"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'DiscountRule/GetAllDiscountRules'
    }
    services["AssignDiscountRule"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'DiscountUserRule/AssignDiscountRule'
    }
    services["DeleteAssignDiscountRule"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'DiscountUserRule/DeleteAssignDiscountRule'
    }
    services["DeleteAssignDiscountRuleDetails"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'DiscountUserRule/DeleteRuleAssignmentDetails'
    }
    services["EditDiscountRuleAssignation"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'DiscountUserRule/EditDiscountRuleAssignation'
    }
    services["GetDiscountUserRules"] = {
        Method: 'Get',
        URL: VisitManagementODataUrl + 'DiscountUserRuleOData'
    }

    services["GetDiscountUserRuleDetails"] = {
        Method: 'Get',
        URL: VisitManagementODataUrl + 'DiscountUserRuleDetailsOData'
    }

    services["GetDiscountRuleDetails"] = {
        Method: 'Get',
        URL: VisitManagementODataUrl + 'DiscountRuleDetailsOData'
    }
    services["GetUserListOData"] = {
        Method: 'Get',
        URL: SecurityOdataServiceUrl + 'UserOdataForContract'
    }
    services["AddItemsOfService"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'ItemsOfService/AddItemsOfService'
    }
    services["EditItemsOfService"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'ItemsOfService/EditItemsOfService'
    }
    services["GetProductsByCategoryIDs"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'ItemsOfService/GetVisitServiceClassificationByIdsList',
    }

    services["GetItemsOfServiceOData"] = {
        Method: 'Get',
        URL: VisitManagementODataUrl + 'ItemsOfServiceOData'
    }

    services["DeleteItemsOfService"] = {
        Method: 'Get',
        URL: VisitManagementUrl + 'ItemsOfService/DeleteItemsOfService'
    }

    services["GetItemsOfServiceByID"] = {
        Method: 'Get',
        URL: VisitManagementUrl + 'ItemsOfService/GetItemsOfServiceByID'
    }

    services["GetProductDetails"] = {
        Method: 'Get',
        URL: pmgtURL + 'Product/GetProductDetails',
    }

    services["GetFilteredWarehouses"] = {
        Method: 'Get',
        URL: pmgtURL + 'Warehouse/GetFilteredWarehouses',
    }
    services["EditVisitServiceReportDisplayMapping"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'Wasele/EditVisitServiceReportDisplayMapping'
    }
    services["DownloadWaseleTemplate"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'Wasele/DownloadWaseleTemplate'
    }
    services["UploadWaseleTemplate"] = {
        Method: 'Post',
        URL: VisitManagementUrl + 'Wasele/UploadWaseleTemplate'
    }

    services["GetBillingInsuranceLKP"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/GetBillingInsuranceLKP'
    }

    //Nphies
    services["GetHIDP"] = {
        Method: 'GET',
        URL: nphiesURL + 'HIDP/GET'
    }

    services["CheckEligibility"] = {
        Method: 'POST',
        URL: nphiesURL + 'Eligibility/CheckEligibility'
    }

    services["GetClaimData"] = {
        Method: 'GET',
        URL: nphiesURL + 'Claim/GetClaimData'
    };

    services["SendClaimRequestByStatement"] = {
        Method: 'POST',
        URL: nphiesURL + 'Claim/SendClaimRequestByStatement'
    };
    services["SingleCancelClaimRequest"] = {
        Method: 'POST',
        URL: nphiesURL + 'Claim/SingleCancelClaimRequest',
    };

    services["GetStatementStatus"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Statement/GetStatementStatus'
    }

    services["GetContractorClients"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Statement/GetContractorClients'
    }

    services["GetContractorStatementSummary"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Statement/GetContractorStatementSummary'
    };

    services["GetVisitNphiesStatus"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Statement/GetVisitNphiesStatus'
    };

    services["StatementVisitsOData"] = {
        Method: 'GET',
        URL: nphiesODataUrl + 'StatementVisitsOData?',
    };


    services["ClaimTransactionHistoryOData"] = {
        Method: 'GET',
        URL: nphiesODataUrl + 'ClaimTransactionHistoryOData?',
    };

    services["SendStatementsToNphies"] = {
        Method: 'PUT',
        URL: VisitManagementUrl + 'Statement/SendStatementsToNphies'
    };

    services["MarkStatementToCancel"] = {
        Method: 'PUT',
        URL: VisitManagementUrl + 'Statement/MarkStatementToCancel'
    };

    //MPI
    services["GetPatientBannerData"] = {
        Method: 'GET',
        URL: mpiURl + 'Patient/GetPatientBannerData'
    }

    services["GetNphiesClaimResponseError"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/GetNphiesClaimResponseError'
    }

    services["GetDisposition"] = {
        Method: 'GET',
        URL: nphiesURL + 'ClaimTransaction/GetDisposition'
    }
    services["GetPatientProblem"] = {
        Method: 'GET',
        URL: nphiesURL + 'PatientProblem/GetProblems'
    }
    services["GetItems"] = {
        Method: 'GET',
        URL: nphiesURL + 'Claim/GetItems'
    }
    services["GetClaimAttachementsWithNote"] = {
        Method: 'GET',
        URL: nphiesURL + 'Claim/GetClaimAttachementsWithNote'
    }
    services["SendClaimRequest"] = {
        Method: 'POST',
        URL: nphiesURL + 'Claim/SendClaimRequest'
    }

    services["GetPatientByID"] = {
        Method: 'GET',
        URL: nphiesURL + 'Patient/GetPatientByID'

    }

    services["GetFinincailInfo"] = {
        Method: 'GET',
        URL: nphiesURL + 'VisitFinincailInfo/GetFinincailInfo'

    }

    services["IsEntityEligible"] = {
        Method: 'GET',
        URL: VisitManagementUrl + 'Visit/IsEntityEligible'
    }

    services["CheckNewbornData"] = {
        Method: 'POST',
        URL: nphiesURL + 'Claim/CheckNewbornData'
    };

    services["GetApprovalLetterStatuses"] = {
        Method: 'GET',
        URL: nphiesURL + 'ApprovalLetterStatus/GetApprovalLetterStatuses'
    };


    services["ReviewedBySupervisorFlag"] = {
        Method: 'POST',
        URL: cpoeURL + 'AdmissionOrderLine/ReviewedBySupervisorFlag'
    };

    services["GetVisitFinincailInfo"] = {
        Method: 'GET',
        URL: nphiesURL + 'VisitFinincailInfo/GetVisitFinincailInfo'

    };

    services["GetAdmissionRequestAndPlannedOrders"] = {
        Method: 'GET',
        URL: nphiesURL + 'IPDAdmissionRequest/GetAdmissionRequestAndPlannedOrders'

    };

    services["GetAdmissionContractor"] = {
        Method: 'GET',
        URL: nphiesURL + 'IPDAdmissionRequest/GetAdmissionContractor'

    };

    services["GetClaimRequests"] = {
        Method: 'GET',
        URL: nphiesURL + 'ClaimTransaction/GetClaimRequests'
    }

    services["CancelClaimByRequestTransactionID"] = {
        Method: 'POST',
        URL: nphiesURL + 'Claim/CancelClaimByRequestTransactionID'
    }

    
    services["SendAdmissionAndPlannedOrders"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Authorization/SendAdmissionAndPlannedOrders'
    };


    services["HoldAdmissionAndPlannedOrders"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Authorization/HoldAdmissionAndPlannedOrders'
    };

    services["ApproveAdmissionAndPlannedOrders"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Authorization/ApproveAdmissionAndPlannedOrders'
    };

    services["RejectAdmissionAndPlannedOrders"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Authorization/RejectAdmissionAndPlannedOrders'
    };

    services["UndoApproveAdmissionAndPlannedOrders"] = {
        Method: 'POST',
        URL: VisitManagementUrl + 'Authorization/UndoApproveAdmissionAndPlannedOrders'
    };



    

    return services;
}